import { makeVar } from "@apollo/client";
import type { G_FetchHomeQuery } from "~/lib/graphql";

type InitialState = {
  /** 削除したい続きから再生のseasonIdを格納する配列 */
  removeContinueWatchingIds: string[];
  /** 画面幅 */
  windowWidth: number;
  /** サブページで表示するタイトル */
  subPageTitle: string;
  /** fetch More時に走るローディングフラグ */
  isLoadingFetchMore: boolean;
  /** ホームヘッダーカルーセルのキャッシュ用 */
  homeItemsCache: G_FetchHomeQuery["home"];
  /** ホームトップ棚のキャッシュ用 */
  homeShelvesCache: G_FetchHomeQuery["home"]["shelves"]["edges"];
};

export const initialState: InitialState = {
  removeContinueWatchingIds: [],
  windowWidth: 0,
  subPageTitle: "",
  isLoadingFetchMore: false,
  homeItemsCache: {} as G_FetchHomeQuery["home"],
  homeShelvesCache: [],
};

export const removeContinueWatchingIdsVar = makeVar(initialState.removeContinueWatchingIds);
export const windowWidthVar = makeVar(initialState.windowWidth);
export const subPageTitleVar = makeVar(initialState.subPageTitle);
export const isLoadingFetchMoreVar = makeVar(initialState.isLoadingFetchMore);
export const homeItemsCacheVar = makeVar<G_FetchHomeQuery["home"]>(initialState.homeItemsCache);
export const homeShelvesCacheVar = makeVar<G_FetchHomeQuery["home"]["shelves"]["edges"]>(initialState.homeShelvesCache);
